/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { MedicalSystemBeamProduction } from './MedicalSystemBeamProduction';
import {
    MedicalSystemBeamProductionFromJSON,
    MedicalSystemBeamProductionFromJSONTyped,
    MedicalSystemBeamProductionToJSON,
} from './MedicalSystemBeamProduction';
import type { MedicalSystemBeamLimitingDeviceType } from './MedicalSystemBeamLimitingDeviceType';
import {
    MedicalSystemBeamLimitingDeviceTypeFromJSON,
    MedicalSystemBeamLimitingDeviceTypeFromJSONTyped,
    MedicalSystemBeamLimitingDeviceTypeToJSON,
} from './MedicalSystemBeamLimitingDeviceType';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { CreateOtherMvTherapyMachineDtoImageLocation } from './CreateOtherMvTherapyMachineDtoImageLocation';
import {
    CreateOtherMvTherapyMachineDtoImageLocationFromJSON,
    CreateOtherMvTherapyMachineDtoImageLocationFromJSONTyped,
    CreateOtherMvTherapyMachineDtoImageLocationToJSON,
} from './CreateOtherMvTherapyMachineDtoImageLocation';
import type { CreateOtherMvTherapyMachineDtoPtw100AreaName } from './CreateOtherMvTherapyMachineDtoPtw100AreaName';
import {
    CreateOtherMvTherapyMachineDtoPtw100AreaNameFromJSON,
    CreateOtherMvTherapyMachineDtoPtw100AreaNameFromJSONTyped,
    CreateOtherMvTherapyMachineDtoPtw100AreaNameToJSON,
} from './CreateOtherMvTherapyMachineDtoPtw100AreaName';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';

/**
 * 
 * @export
 * @interface CreateOtherMvTherapyMachineDto
 */
export interface CreateOtherMvTherapyMachineDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    description?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {MedicalSystemBeamLimitingDeviceType}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    beamLimitingDeviceType?: MedicalSystemBeamLimitingDeviceType;
    /**
     * 
     * @type {MedicalSystemBeamProduction}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    beamProduction?: MedicalSystemBeamProduction;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    sourceAxisDistance: number;
    /**
     * 
     * @type {CreateOtherMvTherapyMachineDtoImageLocation}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    imageLocation?: CreateOtherMvTherapyMachineDtoImageLocation | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    externalRtSystemId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    externalFileSystemPath?: string | null;
    /**
     * 
     * @type {CreateOtherMvTherapyMachineDtoPtw100AreaName}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    ptw100AreaName?: CreateOtherMvTherapyMachineDtoPtw100AreaName | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    $type?: CreateOtherMvTherapyMachineDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOtherMvTherapyMachineDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsCreateOtherMvTherapyMachineDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherMvTherapyMachineDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOtherMvTherapyMachineDtoTypeEnum = typeof CreateOtherMvTherapyMachineDtoTypeEnum[keyof typeof CreateOtherMvTherapyMachineDtoTypeEnum];



/**
 * Check if a given object implements the CreateOtherMvTherapyMachineDto interface.
 */
export function instanceOfCreateOtherMvTherapyMachineDto(value?: unknown): value is CreateOtherMvTherapyMachineDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOtherMvTherapyMachineDtoTypeEnum)[0];
}

export function CreateOtherMvTherapyMachineDtoFromJSON(json: any): CreateOtherMvTherapyMachineDto {
    return CreateOtherMvTherapyMachineDtoFromJSONTyped(json, false);
}

export function CreateOtherMvTherapyMachineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherMvTherapyMachineDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'typeSpecification': json['typeSpecification'] == null ? undefined : json['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'beamLimitingDeviceType': json['beamLimitingDeviceType'] == null ? undefined : MedicalSystemBeamLimitingDeviceTypeFromJSON(json['beamLimitingDeviceType']),
        'beamProduction': json['beamProduction'] == null ? undefined : MedicalSystemBeamProductionFromJSON(json['beamProduction']),
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'sourceAxisDistance': json['sourceAxisDistance'],
        'imageLocation': json['imageLocation'] == null ? undefined : CreateOtherMvTherapyMachineDtoImageLocationFromJSON(json['imageLocation']),
        'externalRtSystemId': json['externalRtSystemId'] == null ? undefined : json['externalRtSystemId'],
        'externalFileSystemPath': json['externalFileSystemPath'] == null ? undefined : json['externalFileSystemPath'],
        'ptw100AreaName': json['ptw100AreaName'] == null ? undefined : CreateOtherMvTherapyMachineDtoPtw100AreaNameFromJSON(json['ptw100AreaName']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateOtherMvTherapyMachineDtoToJSON(value?: CreateOtherMvTherapyMachineDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'description': value['description'],
        'category': RtSystemCategoryToJSON(value['category']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'imageId': value['imageId'],
        'isAvailable': value['isAvailable'],
        'isArchived': value['isArchived'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'typeSpecification': value['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryToJSON(value['subCategory']),
        'beamLimitingDeviceType': MedicalSystemBeamLimitingDeviceTypeToJSON(value['beamLimitingDeviceType']),
        'beamProduction': MedicalSystemBeamProductionToJSON(value['beamProduction']),
        'serialNumber': value['serialNumber'],
        'sourceAxisDistance': value['sourceAxisDistance'],
        'imageLocation': CreateOtherMvTherapyMachineDtoImageLocationToJSON(value['imageLocation']),
        'externalRtSystemId': value['externalRtSystemId'],
        'externalFileSystemPath': value['externalFileSystemPath'],
        'ptw100AreaName': CreateOtherMvTherapyMachineDtoPtw100AreaNameToJSON(value['ptw100AreaName']),
        '$type': value['$type'],
    });
}

